import { Box, Center, Text } from '@chakra-ui/react'
import _ from 'lodash'
import { ItListItem } from 'types/graphql'

import Loader from 'src/components/widgets/Loader/Loader'

import { ScraperProps } from '../Scraper'

import Prefill from './Prefill/Prefill'
import useScraperInner from './useScraperInner'

const ScraperInner: React.FC<ScraperProps & { item: ItListItem }> = ({
  onBeforeUpdate,
  children,
  item,
}) => {
  const { creatorBrandColor, load, onClick, hasRetrievedInfo, hasError } =
    useScraperInner(item, onBeforeUpdate)

  return (
    <Box>
      {!load && !hasRetrievedInfo && (
        <Prefill
          hasError={hasError}
          itemType={item.type}
          creatorBrandColor={creatorBrandColor}
          onClick={onClick}
        />
      )}
      {hasRetrievedInfo && children}
      {load && (
        <Center flexDirection="column" my={14}>
          <Loader show />
          <Text className="body-extra-small" color="stone" mt={4}>
            Looking for image and title...
          </Text>
        </Center>
      )}
    </Box>
  )
}

export default ScraperInner
